import { render } from "./PremiumPlaceholder.vue?vue&type=template&id=38ee64e0"
import script from "./PremiumPlaceholder.vue?vue&type=script&lang=js"
export * from "./PremiumPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__